import { useIntl } from 'react-intl';

import { useCohort } from '@/components/user-context/helpers/cohorts';

import { LoggedInBlueWaveTemplateJsmExistingUser } from '../../components/blue-wave-template-jam-existing-user';
import { LoggedInBlueWaveTemplateJsmNewUser } from '../../components/blue-wave-template-jsm-new-user';

export const LoggedInJsmPremium = () => {
	const { formatMessage } = useIntl();
	const cohort = useCohort();

	if (cohort === 'new-user') {
		return (
			<LoggedInBlueWaveTemplateJsmNewUser
				productEditionText={formatMessage({
					id: 'WacSignupHeader.cloudPremium',
					defaultMessage: 'Cloud Premium',
				})}
			/>
		);
	}

	if (cohort) {
		return (
			<LoggedInBlueWaveTemplateJsmExistingUser
				productEditionText={formatMessage({
					id: 'WacSignupHeader.cloudPremium',
					defaultMessage: 'Cloud Premium',
				})}
			/>
		);
	}

	return null;
};
